import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardBody,
  Heading,
  Input,
  Text,
  VStack,
  HStack,
  Flex,
  Spacer,
  Center,
} from '@chakra-ui/react';

const ExpCard = (target) => {
  const [hp, setHp] = useState('');
  const [mp, setMp] = useState('');
  const [targetHp, setTargetHp] = useState('');
  const [targetMp, setTargetMp] = useState('');

  const [expHp, setExpHp] = useState(0);
  const [expMp, setExpMp] = useState(0);
  const [exp, setExp] = useState(0);

  const expLogic = (type, pure, target) => {
    const list = [];

    const diffPure = type === 'hp' ? 50 : 25;
    const diffExp = type === 'hp' ? 25000 : 12500;

    const pureLength = Math.floor(pure / diffPure);
    const targetLength = Math.floor(target / diffPure);

    for (let i = 0; i <= targetLength; i++) {
      list[i] = { pure: i * diffPure, exp: i * diffExp };
    }

    let totalExp = 0;
    for (let i = pureLength + 1; i <= targetLength; i++) {
      totalExp += list[i].exp;
    }

    return totalExp;
  };

  const calculateExp = (e) => {
    const hpValue = expLogic('hp', hp, targetHp);
    setExpHp(hpValue);

    const mpValue = expLogic('mp', mp, targetMp);
    setExpMp(mpValue);

    setExp(hpValue + mpValue);
  };

  const resetClickListener = () => {
    setHp('');
    setMp('');
    setTargetHp('');
    setTargetMp('');
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    const nValue = value.replace(/,/g, '');
    if (id === 'pure-hp') {
      setHp(nValue);
    } else if (id === 'pure-mp') {
      setMp(nValue);
    } else if (id === 'target-hp') {
      setTargetHp(nValue);
    } else if (id === 'target-mp') {
      setTargetMp(nValue);
    }
  };

  useEffect(() => {
    // hp or mp or other type
    const { hp, mp } = target.value;
    if (target.type === 'hp') {
      setTargetHp(hp.toLocaleString());
    }
    if (target.type === 'mp') {
      setTargetMp(mp.toLocaleString());
    }
    if (target.type === 'job') {
      setTargetHp(hp.toLocaleString());
      setTargetMp(mp.toLocaleString());
    }
  }, [target]);

  return (
    <Card maxW={400}>
      <CardBody p={2}>
        <Heading size='md'>체마계산기</Heading>
        <VStack mt={2}>
          <HStack>
            <Input
              id='pure-hp'
              placeholder='현재체력'
              value={hp === '' ? '' : Number(hp).toLocaleString()}
              onChange={handleInputChange}
            />
            <Input
              id='target-hp'
              placeholder='목표체력'
              value={targetHp === '' ? '' : Number(targetHp).toLocaleString()}
              onChange={handleInputChange}
            />
          </HStack>
          <HStack>
            <Input
              id='pure-mp'
              placeholder='현재마력'
              value={mp === '' ? '' : Number(mp).toLocaleString()}
              onChange={handleInputChange}
            />
            <Input
              id='target-mp'
              placeholder='목표마력'
              value={targetMp === '' ? '' : Number(targetMp).toLocaleString()}
              onChange={handleInputChange}
            />
          </HStack>
        </VStack>
        <Flex mt={2}>
          <Center>
            <Text>필요 경험치</Text>
          </Center>

          <Spacer />
          <Button
            mr={2}
            size={'sm'}
            variant='outline'
            onClick={resetClickListener}
            textColor={'grey'}
          >
            초기화
          </Button>
          <Button size={'sm'} variant='outline' onClick={calculateExp}>
            계산하기
          </Button>
        </Flex>
        <Box p={2}>
          <Text
            borderRadius='2px'
            _hover={{ bg: '#ebedf0', cursor: 'pointer' }}
          >
            {`체력: ${expHp.toLocaleString()}`}
          </Text>
          <Text
            borderRadius='2px'
            _hover={{ bg: '#ebedf0', cursor: 'pointer' }}
          >
            {`마력: ${expMp.toLocaleString()}`}
          </Text>
          <Text
            borderRadius='2px'
            _hover={{ bg: '#ebedf0', cursor: 'pointer' }}
          >
            {`전체: ${exp.toLocaleString()}`}
          </Text>
        </Box>
      </CardBody>
    </Card>
  );
};

export default ExpCard;
